import { Box, Button, ButtonProps, CircularProgress, Typography } from '@mui/material';
import classes from './CountingButton.module.css';

export function CountingButton(props: { count: number } & Omit<ButtonProps, 'startIcon'> & React.ComponentPropsWithoutRef<'button'>) {
    const { count, loading, onClick, ...rest } = props;
    return (
        <Button
            {...rest}
            sx={{
                '& .MuiButton-startIcon': {
                    ml: -1,
                },
                height: 36,
                px: 1.75,
            }}
            startIcon={
                <Box
                    sx={(theme) => ({
                        backgroundColor: (theme.vars || theme).palette.background.default,
                        px: 1,
                        borderRadius: 32,
                        height: 24,
                        alignItems: 'center',
                        display: 'flex',
                        position: 'relative',
                    })}
                >
                    <Typography color='primary.dark'>{count}</Typography>
                </Box>
            }
            endIcon={loading ? <CircularProgress size={20} /> : props.endIcon}
            variant='contained'
            className={classes.root}
            disabled={loading || count <= 0}
            onClick={(e) => {
                if (loading) {
                    e.stopPropagation();
                    e.preventDefault();
                } else {
                    onClick?.(e);
                }
            }}
        />
    );
}
